"use client";

import { FullScreenIcon } from "@/icons";
import { useCallback, useState } from "react";
import CustomICon from "./CustomIcon";

const FullScreenComponent = () => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  const handleFullScreen = useCallback(() => {
    if (!isFullscreen || !document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setIsFullscreen(true);
    } else {
      document.exitFullscreen();
      setIsFullscreen(false);
    }
  }, [isFullscreen]);

  return (
    <CustomICon onClick={handleFullScreen}>
      <FullScreenIcon sx={{ fontSize: 16 }} />
    </CustomICon>
  );
};

export default FullScreenComponent;
